export default __webpack_public_path__ + "static/media/bg1.9889882d.png";